<template>
    <b-row class="w-100">
      <b-col md="12">
        <div class="clearfix centerDiv">
          <h3 class="pt-3">{{$t(this.$getConst.pages.error.error_message_+this.$store.getters["auth/scopeDefault"].name)}}</h3>
        </div>
      </b-col>
    </b-row>
</template>

<script>
  export default {
    name: 'Page500'
  }
</script>
<style>
  .centerDiv{
    margin: 15%
  }
</style>
